const NOMINATION_EXCEL_STYLES = [
    {
        id: 'nmntn-nonedit',
        alignment: {
            vertical: 'Center',
        },
        interior: {
            color: '#ffffff',
            pattern: 'Solid',
            patternColor: undefined
        },
        borders: {
            borderBottom: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderLeft: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderRight: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderTop: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
        },
        font: {
            color: '#000000',
            size: 10
        }
    },
    {
        id: 'grid-cell-yellow',
        alignment: {
            vertical: 'Center',
        },
        interior: {
            color: '#ffffe0',
            pattern: 'Solid',
            patternColor: undefined
        },
        borders: {
            borderBottom: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderLeft: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderRight: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderTop: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
        },
        font: {
            color: '#000000',
            size: 10
        },
        numberFormat: {
            format: "#,##0.00; (#,##0.00)"
        }
    },
    {
        id: 'grid-cell-red',
        alignment: {
            vertical: 'Center',
        },
        interior: {
            color: '#f08080',
            pattern: 'Solid',
            patternColor: undefined
        },
        borders: {
            borderBottom: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderLeft: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderRight: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderTop: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
        },
        font: {
            color: '#000000',
            size: 10
        },
        numberFormat: {
            format: '#,##0; (#,##0)',
        }
    },
    {
        id: 'nmntn-nonedit-number',
        alignment: {
            vertical: 'Center',
        },
        interior: {
            color: '#ffffff',
            pattern: 'Solid',
            patternColor: undefined
        },
        borders: {
            borderBottom: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderLeft: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderRight: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderTop: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
        },
        font: {
            color: '#000000',
            size: 10
        },
        numberFormat: {
            format: '#,##0; (#,##0)',
        }
    },
    {
        id: 'nmntn-nonedit-decimal',
        alignment: {
            vertical: 'Center',
        },
        interior: {
            color: '#ffffff',
            pattern: 'Solid',
            patternColor: undefined
        },
        borders: {
            borderBottom: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderLeft: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderRight: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderTop: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
        },
        font: {
            color: '#000000',
            size: 10
        },
        numberFormat: {
            format: "#,##0.00; (#,##0.00)"
        }
    },
    {
        id: 'nmntn-txt',
        alignment: {
            vertical: 'Center',
        },
        interior: {
            color: '#ffffff',
            pattern: 'Solid',
            patternColor: undefined
        },
        borders: {
            borderBottom: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderLeft: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderRight: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderTop: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
        },
        font: {
            color: '#000000',
            size: 10
        }
    },
    {
        id: 'nmntn-number',
        alignment: {
            vertical: 'Center',
        },
        interior: {
            color: '#ffffff',
            pattern: 'Solid',
            patternColor: undefined
        },
        borders: {
            borderBottom: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderLeft: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderRight: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderTop: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
        },
        font: {
            color: '#000000',
            size: 10
        },
        numberFormat: {
            format: '#,##0; (#,##0)',
        }
    },
    {
        id: 'nmntn-decimal',
        alignment: {
            vertical: 'Center',
        },
        interior: {
            color: '#ffffff',
            pattern: 'Solid',
            patternColor: undefined
        },
        borders: {
            borderBottom: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderLeft: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderRight: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderTop: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
        },
        font: {
            color: '#000000',
            size: 10
        },
        numberFormat: {
            format: "#,##0.00; (#,##0.00)"
        }
    },
    {
        id: 'cell-wrap-text nmntn-txt',
        alignment: {
            vertical: 'Center',
        },
        interior: {
            color: '#ffffff',
            pattern: 'Solid',
            patternColor: undefined
        },
        borders: {
            borderBottom: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderLeft: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderRight: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderTop: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
        },
        font: {
            color: '#000000',
            size: 10
        }
    },
    {
        id: 'cell-wrap-text nmntn-nonedit',
        alignment: {
            vertical: 'Center',
        },
        interior: {
            color: '#ffffff',
            pattern: 'Solid',
            patternColor: undefined
        },
        borders: {
            borderBottom: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderLeft: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderRight: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderTop: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
        },
        font: {
            color: '#000000',
            size: 10
        }
    },
    {
        id: 'nmntn-nonedit-number-center',
        alignment: {
            vertical: 'Center',
        },
        interior: {
            color: '#ffffff',
            pattern: 'Solid',
            patternColor: undefined,
        },
        font: {
            bold: true,
            color: '#000000',
            size: 10
        },
        numberFormat: {
            format: '#,##0; (#,##0)',
        }
    },
    {
        id: 'header',
        alignment: {
            vertical: 'Center',
        },
        interior: {
            color: '#01205f',
            pattern: 'Solid',
            patternColor: undefined,
        },
        font: {
            bold: true,
            color: '#ffffff',
            size: 10
        }
    },
    {
        id: 'nmntn-today',
        interior: {
            color: '#c8efb7',
            pattern: 'Solid',
            patternColor: undefined,
        },
        borders: {
            borderBottom: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderLeft: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderRight: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderTop: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
        },
        font: {
            color: '#000000',
            size: 10
        }
    },
    {
        id: 'cell-wrap-text nmntn-today',
        interior: {
            color: '#c8efb7',
            pattern: 'Solid',
            patternColor: undefined,
        },
        borders: {
            borderBottom: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderLeft: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderRight: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderTop: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
        },
        font: {
            color: '#000000',
            size: 10
        }
    },
    {
        id: 'nmntn-number-today',
        interior: {
            color: '#c8efb7',
            pattern: 'Solid',
            patternColor: undefined,
        },
        borders: {
            borderBottom: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderLeft: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderRight: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderTop: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
        },
        font: {
            color: '#000000',
            size: 10
        },
        numberFormat: {
            format: '#,##0; (#,##0)',
        }
    },
    {
        id: 'nmntn-decimal-today',
        interior: {
            color: '#c8efb7',
            pattern: 'Solid',
            patternColor: undefined,
        },
        borders: {
            borderBottom: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderLeft: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderRight: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
            borderTop: {
                color: '#5a5a5a',
                lineStyle: 'Continuous',
                weight: 1,
            },
        },
        font: {
            color: '#000000',
            size: 10
        },
        numberFormat: {
            format: "#,##0.00;(#,##0.00)"
        }
    },
    {
        id: 'nmntn-ftr-dark',
        alignment: {
            vertical: 'Center',
        },
        interior: {
            color: '#01205f',
            pattern: 'Solid',
            patternColor: undefined,
        },
        font: {
            bold: true,
            color: '#ffffff',
            size: 10
        }
    },
    {
        id: 'nmntn-ftr-dark-cover',
        alignment: {
            vertical: 'Center',
        },
        interior: {
            color: '#01205f',
            pattern: 'Solid',
            patternColor: undefined,
        },
        font: {
            bold: true,
            color: '#01205f',
            size: 10
        }
    },
    {
        id: 'nmntn-ftr-dark-number',
        alignment: {
            vertical: 'Center',
        },
        interior: {
            color: '#01205f',
            pattern: 'Solid',
            patternColor: undefined,
        },
        font: {
            bold: true,
            color: '#ffffff',
            size: 10
        },
        numberFormat: {
            format: '#,##0; (#,##0)',
        }
    },
    {
        id: 'nmntn-ftr-light-title',
        alignment: {
            vertical: 'Center',
        },
        interior: {
            color: '#ffffff',
            pattern: 'Solid',
            patternColor: undefined,
        },
        font: {
            bold: true,
            color: '#000000',
            size: 10
        }
    },
    {
        id: 'nmntn-ftr-light-cover',
        alignment: {
            vertical: 'Center',
        },
        interior: {
            color: '#ffffff',
            pattern: 'Solid',
            patternColor: undefined,
        },
        font: {
            bold: true,
            color: '#ffffff',
            size: 10
        }
    },
    {
        id: 'nmntn-ftr-light',
        alignment: {
            vertical: 'Center',
        },
        interior: {
            color: '#ffffff',
            pattern: 'Solid',
            patternColor: undefined,
        },
        font: {
            bold: true,
            color: '#000000',
            size: 10
        },
        numberFormat: {
            format: '#,##0; (#,##0)',
        }
    },
    {
        id: "cell",
        font: {
            color: '#000000',
            size: 10
        }
    }
]
export default NOMINATION_EXCEL_STYLES